import Flickity from 'flickity';
import IMGFlickity from 'flickity-imagesloaded';

// flickering fix for ie
const { focus } = Flickity.prototype;

const dragThresholdSize = 10;

Flickity.prototype.focus = function () {
	// use non-standard setActive for IE11. #651
	if (this.element.setActive) {
		this.element.setActive();
		return;
	}
	// use default
	// eslint-disable-next-line prefer-rest-params
	focus.apply(this, arguments);
};

// flickity height fix
// eslint-disable-next-line no-underscore-dangle
Flickity.prototype._createResizeClass = function () {
	setTimeout(() => {
		this.element.classList.add('flickity-resize');
	});
};
Flickity.createMethods.push('_createResizeClass');

const { resize } = Flickity.prototype;
Flickity.prototype.resize = function () {
	this.element.classList.remove('flickity-resize');
	resize.call(this);
	this.element.classList.add('flickity-resize');
};

/**
 * *******************************
 * content assets carousel
 * *******************************
*/
const contentCarousels = document.querySelectorAll('.assets-carousel-block');

const createTCarousel = function(carouselContainer) {
    const assets = carouselContainer.querySelector('.assets-carousel');
    new Flickity(assets, {
        wrapAround: false,
        cellAlign: "left",
        contain: true,
        pageDots: true,
        prevNextButtons: false,
    });
}

contentCarousels.forEach(elem => {
    createTCarousel(elem);
});

/**
 * *******************************
 * njt carousel
 * *******************************
*/
const njtCarousel = document.querySelector('.njt-carousel');

if (njtCarousel) {
    new Flickity(njtCarousel, {
        wrapAround: false,
        cellAlign: "left",
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        watchCSS: true,
        imagesLoaded: true
    });
}

/**
 * *******************************
 * mersey travel carousel
 * *******************************
*/
const merseyCarousel = document.querySelector('.mersey-carousel');

if (merseyCarousel) {
    new Flickity(merseyCarousel, {
        wrapAround: false,
        cellAlign: "left",
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        watchCSS: true,
        imagesLoaded: true
    });
}

/**
 * *******************************
 * dine carousel
 * *******************************
*/
const dineCarousel = document.querySelector('.dine-carousel');

if (dineCarousel) {
    new Flickity(dineCarousel, {
        wrapAround: false,
        cellAlign: "left",
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        watchCSS: true,
        imagesLoaded: true
    });
}

/**
 * *******************************
 * wgs carousel
 * *******************************
*/
const wgsCarousel = document.querySelector('.wgs-carousel');

if (wgsCarousel) {
    new Flickity(wgsCarousel, {
        wrapAround: false,
        cellAlign: "left",
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        watchCSS: true,
        imagesLoaded: true
    });
}

/**
 * *******************************
 * livewelldorset carousel
 * *******************************
*/
const livewelldorsetDesignCarousel = document.querySelector('.livewelldorset-design-carousel');

if (livewelldorsetDesignCarousel) {
    new Flickity(livewelldorsetDesignCarousel, {
        wrapAround: false,
        cellAlign: "left",
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        watchCSS: true,
        imagesLoaded: true
    });
}

const livewelldorsetCarousel = document.querySelector('.livewelldorset-carousel');

if (livewelldorsetCarousel) {
    new Flickity(livewelldorsetCarousel, {
        wrapAround: false,
        cellAlign: "left",
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        watchCSS: true,
        imagesLoaded: true
    });
}

/**
 * *******************************
 * Eastleigh college carousel
 * *******************************
*/
const eastleighTimelineCarousel = document.querySelector('.eastleigh-timeline-carousel');

if (eastleighTimelineCarousel) {
    new Flickity(eastleighTimelineCarousel, {
        wrapAround: false,
        cellAlign: "left",
        contain: true,
        pageDots: false,
        prevNextButtons: false,
    });
}

const eastleighSocialCarousel = document.querySelector('.eastleigh-social-carousel');

if (eastleighSocialCarousel) {
    new Flickity(eastleighSocialCarousel, {
        wrapAround: false,
        cellAlign: "left",
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        watchCSS: true,
        imagesLoaded: true
    });
}

/**
 * *******************************
 * postgoldforcash carousel
 * *******************************
*/
const postgoldforcashCarousel = document.querySelector('.postgoldforcash-carousel');

if (postgoldforcashCarousel) {
    new Flickity(postgoldforcashCarousel, {
        wrapAround: false,
        cellAlign: "left",
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        watchCSS: true,
        imagesLoaded: true
    });
}

/**
 * *******************************
 * logos carousel
 * *******************************
*/
const logoCarousels = document.querySelectorAll('.logos-carousel-container');

const createLCarousel = function(carouselContainer) {
    const lCarousel = carouselContainer.querySelector('.logos-carousel');
    new Flickity(lCarousel, {
        wrapAround: false,
        cellAlign: "left",
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        watchCSS: true,
        imagesLoaded: true
    });
}

logoCarousels.forEach(elem => {
    createLCarousel(elem);
});

/**
 * *******************************
 * work template carousel
 * *******************************
*/
const wtCarousels = document.querySelectorAll('.wtCarouselContainer');

const createWTCarousel = function(carouselContainer) {
    const wtCarousel = carouselContainer.querySelector('.wtCarousel');
    new Flickity(wtCarousel, {
        wrapAround: false,
        cellAlign: "left",
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        watchCSS: true,
        imagesLoaded: true
    });
}

wtCarousels.forEach(elem => {
    createWTCarousel(elem);
});

/**
 * *******************************
 * services carousel
 * *******************************
 */
const createSCarousel = function (carouselContainer) {
	const sCarousel = carouselContainer.querySelector('.services-carousel');
    if (!sCarousel) return null;

    return new Flickity(sCarousel, {
        wrapAround: false,
        cellAlign: "left",
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        watchCSS: true,
        imagesLoaded: true
    });
};

export { createSCarousel };